import type { BuildingConfig, BuildingCost, BuildingType } from '../types/building.ts';

export const BUILDINGS_CONFIG: Record<BuildingType, BuildingConfig> = {
  command_center: {
    type: 'command_center',
    name: 'Trung Tâm Chỉ Huy',
    description: 'Trái tim của căn cứ. Giới hạn cấp độ tối đa của các công trình khác.',
    max_level: 20,
    base_cost: { metal: 200, he3: 100, credits: 50 },
    cost_multiplier: 1.45,
    base_build_time_sec: 25,
    build_time_multiplier: 1.4,
  },
  metal_mine: {
    type: 'metal_mine',
    name: 'Mỏ Kim Loại',
    description: 'Khai thác kim loại hợp kim tự động từ bề mặt hành tinh.',
    max_level: 20,
    base_cost: { metal: 120, he3: 40, credits: 20 },
    cost_multiplier: 1.4,
    base_build_time_sec: 15,
    build_time_multiplier: 1.35,
  },
  he3_refinery: {
    type: 'he3_refinery',
    name: 'Nhà Máy Chiết Xuất He-3',
    description: 'Chiết xuất và tinh chế khí hiếm Heli-3 dùng cho năng lượng cao cấp.',
    max_level: 20,
    base_cost: { metal: 150, he3: 80, credits: 30 },
    cost_multiplier: 1.42,
    base_build_time_sec: 20,
    build_time_multiplier: 1.35,
  },
  commerce_hub: {
    type: 'commerce_hub',
    name: 'Trung Tâm Thương Mại',
    description: 'Tạo dòng tiền Tín Dụng từ các tuyến mậu dịch tự do trong thiên hà.',
    max_level: 20,
    base_cost: { metal: 100, he3: 60, credits: 50 },
    cost_multiplier: 1.38,
    base_build_time_sec: 15,
    build_time_multiplier: 1.3,
  },
  storage_vault: {
    type: 'storage_vault',
    name: 'Kho Chứa Tài Nguyên',
    description: 'Bảo quản Kim loại và Heli-3, tăng dung lượng chứa tối đa của hành tinh.',
    max_level: 20,
    base_cost: { metal: 220, he3: 120, credits: 40 },
    cost_multiplier: 1.4,
    base_build_time_sec: 25,
    build_time_multiplier: 1.35,
  },
  shipyard: {
    type: 'shipyard',
    name: 'Xưởng Đóng Tàu',
    description: 'Sản xuất và lắp ráp các loại chiến hạm từ bản vẽ thiết kế.',
    max_level: 20,
    base_cost: { metal: 300, he3: 180, credits: 100 },
    cost_multiplier: 1.48,
    base_build_time_sec: 35,
    build_time_multiplier: 1.4,
  },
  research_lab: {
    type: 'research_lab',
    name: 'Viện Nghiên Cứu',
    description: 'Phát triển công nghệ tiên tiến để mở khóa vũ khí và module mới.',
    max_level: 20,
    base_cost: { metal: 260, he3: 220, credits: 80 },
    cost_multiplier: 1.46,
    base_build_time_sec: 30,
    build_time_multiplier: 1.38,
  },
};

export function calculateBuildingUpgradeCost(type: BuildingType, currentLevel: number): BuildingCost {
  const cfg = BUILDINGS_CONFIG[type];
  const mult = Math.pow(cfg.cost_multiplier, currentLevel);
  return {
    metal: Math.floor(cfg.base_cost.metal * mult),
    he3: Math.floor(cfg.base_cost.he3 * mult),
    credits: Math.floor(cfg.base_cost.credits * mult),
  };
}

export function calculateBuildingUpgradeTimeSec(type: BuildingType, currentLevel: number): number {
  const cfg = BUILDINGS_CONFIG[type];
  const mult = Math.pow(cfg.build_time_multiplier, currentLevel);
  return Math.max(5, Math.floor(cfg.base_build_time_sec * mult));
}

export function calculateProductionRates(buildings: { type: BuildingType; level: number }[]) {
  let metalRate = 120; // Base rate per hour
  let he3Rate = 60;
  let creditsRate = 40;
  let maxMetal = 10000;
  let maxHe3 = 5000;

  for (const b of buildings) {
    if (b.level <= 0) continue;
    if (b.type === 'metal_mine') {
      metalRate += Math.floor(150 * Math.pow(1.35, b.level - 1));
    } else if (b.type === 'he3_refinery') {
      he3Rate += Math.floor(90 * Math.pow(1.35, b.level - 1));
    } else if (b.type === 'commerce_hub') {
      creditsRate += Math.floor(60 * Math.pow(1.32, b.level - 1));
    } else if (b.type === 'storage_vault') {
      maxMetal += Math.floor(8000 * Math.pow(1.4, b.level - 1));
      maxHe3 += Math.floor(4000 * Math.pow(1.4, b.level - 1));
    }
  }

  return { metalRate, he3Rate, creditsRate, maxMetal, maxHe3 };
}
